<template>
    <div v-html="'Contact'"/>
</template>

<script>
export default { name: "Contact" };
</script>